export default function VisionSection() {
  const visions = [
    '神奈川県ベンチプレス大会の59kg級歴代記録の更新&優勝',
    '全国大会入賞',
    '全国大会優勝',
    '世界大会優勝'
  ];

  return (
    <section id="vision" className="relative py-32 px-6 lg:px-12 overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/304f976c2ea57fcbbd8a9dee124facf9.jpg"
          alt="Vision Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>
      
      <div className="relative z-10 max-w-5xl mx-auto text-center">
        <h2 className="text-7xl md:text-8xl font-black text-white mb-8 tracking-wider" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.1em' }}>
          MY VISION
        </h2>
        
        <div className="space-y-6 mb-16 max-w-3xl mx-auto">
          {visions.map((vision, index) => (
            <div key={index} className="flex items-start gap-4 text-left group">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-orange-500 flex items-center justify-center mt-1">
                <i className="ri-check-line text-white text-lg"></i>
              </div>
              <p className="text-white text-lg font-medium leading-relaxed group-hover:text-orange-300 transition-colors" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                {vision}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}